import { Alert } from '@interstate/components/Alert';
import { Modal } from '@interstate/components/Modal';
import { useEffect, useState } from 'react';

interface FailedUpdateOfferProps {
    onClose?: () => void;
    show: boolean;
}

export const FailedUpdateOffer = ({ onClose, show }: FailedUpdateOfferProps) => {
    const [isVisible, setIsVisible] = useState(show);

    useEffect(() => {
        setIsVisible(show);
    }, [show]);

    const handleFailedUpdateOfferNoticeClose = () => {
        setIsVisible(false);
        if (onClose) {
            onClose();
        }
    };

    return (
        <Modal
            data-testid="failed-update-offer-modal-test-id"
            footer={{
                primary: {
                    action: handleFailedUpdateOfferNoticeClose,
                    label: 'Close'
                }
            }}
            header="Update Offer"
            id="failed-update-offer-modal-id"
            onHide={handleFailedUpdateOfferNoticeClose}
            size="small"
            show={isVisible}
        >
            <Alert type="error">
                <span>The changes you made to this offer failed to update. Please try again.</span>
            </Alert>
            <div style={{ flexDirection: 'column', display: 'flex', gap: '1rem', marginTop: '1rem' }}>
                <p>We ran into a problem updating this offer so the information wasn't shared. Please try again.</p>
                <p>
                    <strong>If the problem persists, please contact support:</strong> 1-888-895-2994 or create a support ticket.
                </p>
            </div>
        </Modal>
    );
};
